import React from "react";

// 날짜/시간 입력 처리를 위한 공통 함수
const handleDateTimeInput = (e, currentValue, handleChange, dtDisplay) => {
  const input = e.target.value;
  const fieldName = e.target.name;

  // 백스페이스 처리
  if (input.length < (dtDisplay(currentValue) || "").length) {
    handleChange(e);
    return;
  }

  // 숫자만 추출
  const numbers = input.replace(/\D/g, "");

  if (numbers.length <= 12) {
    let formattedValue = numbers;

    // 날짜 시간 포맷팅
    if (numbers.length >= 4) {
      formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
    }
    if (numbers.length >= 6) {
      formattedValue =
        formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
    }
    if (numbers.length >= 8) {
      formattedValue =
        formattedValue.slice(0, 10) + " " + formattedValue.slice(10);
    }
    if (numbers.length >= 10) {
      formattedValue =
        formattedValue.slice(0, 13) + ":" + formattedValue.slice(13);
    }

    handleChange({
      target: {
        name: fieldName,
        value: formattedValue,
      },
    });
  }
};

const InitialPage = ({
  formData,
  handleChange,
  handleCheckboxChange,
  dtDisplay,
}) => {
  // 디버깅 로그 추가
  console.group("[InitialPage] Render");
  console.log("Received formData:", formData);
  console.log("hos_id:", formData.hos_id);
  console.log("hospital:", formData.hospital);
  console.groupEnd();

  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;
    console.log("[InitialPage] Radio Click:", {
      name,
      value,
      current: formData[name],
    });

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      // 이미 선택된 상태라면 해제
      handleChange({ target: { name, value: "" } });
    } else {
      // 다른 값이라면 선택
      handleChange({ target: { name, value } });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러
  const handlePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 12) {
      // 자동 포맷팅 적용
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }
      if (numbers.length >= 8) {
        formattedValue =
          formattedValue.slice(0, 10) + " " + formattedValue.slice(10);
      }
      if (numbers.length >= 10) {
        formattedValue =
          formattedValue.slice(0, 13) + ":" + formattedValue.slice(13);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  // 날짜/시간 입력 필드를 위한 공통 렌더링 함수
  const renderDateTimeField = (fieldName) => (
    <div className="input_2col">
      <input
        type="text"
        name={fieldName}
        placeholder="YYYY-MM-DD HH:MM"
        value={dtDisplay(formData[fieldName])}
        onChange={(e) =>
          handleDateTimeInput(e, formData[fieldName], handleChange, dtDisplay)
        }
        onPaste={(e) => handlePaste(e, fieldName)}
      />
    </div>
  );

  // 숫자만 입력받아 자동 포맷팅하는 날짜 필드 렌더링 함수
  const renderSpecialDateField = (fieldName, placeholder = "YYYY-MM-DD") => {
    const formatTimeInput = (value) => {
      // 숫자만 추출
      const numbersOnly = value.replace(/\D/g, "");

      // 최대 8자리까지만 허용
      const limitedNumbers = numbersOnly.slice(0, 8);

      // 포맷팅 적용
      if (limitedNumbers.length <= 4) {
        return limitedNumbers;
      } else if (limitedNumbers.length <= 6) {
        return `${limitedNumbers.slice(0, 4)}-${limitedNumbers.slice(4)}`;
      } else {
        return `${limitedNumbers.slice(0, 4)}-${limitedNumbers.slice(
          4,
          6
        )}-${limitedNumbers.slice(6)}`;
      }
    };

    const handleSpecialTimeChange = (e) => {
      const formattedValue = formatTimeInput(e.target.value);
      handleChange({ target: { name: fieldName, value: formattedValue } });
    };

    return (
      <div className="input_2col">
        <input
          type="text"
          name={fieldName}
          placeholder={placeholder}
          value={formData[fieldName] || ""}
          onChange={handleSpecialTimeChange}
          maxLength={10} // YYYY-MM-DD 형식의 최대 길이
        />
      </div>
    );
  };

  // 숫자만 입력받아 자동 포맷팅하는 DateTime 필드 렌더링 함수
  const renderSpecialTimeField = (
    fieldName,
    placeholder = "YYYY-MM-DD HH:MM"
  ) => {
    const formatDateTimeInput = (value) => {
      // 숫자만 추출
      const numbersOnly = value.replace(/\D/g, "");

      // 최대 12자리까지만 허용 (YYYYMMDDHHMM)
      const limitedNumbers = numbersOnly.slice(0, 12);

      // 포맷팅 적용
      if (limitedNumbers.length <= 4) {
        return limitedNumbers;
      } else if (limitedNumbers.length <= 6) {
        return `${limitedNumbers.slice(0, 4)}-${limitedNumbers.slice(4)}`;
      } else if (limitedNumbers.length <= 8) {
        return `${limitedNumbers.slice(0, 4)}-${limitedNumbers.slice(
          4,
          6
        )}-${limitedNumbers.slice(6)}`;
      } else if (limitedNumbers.length <= 10) {
        return `${limitedNumbers.slice(0, 4)}-${limitedNumbers.slice(
          4,
          6
        )}-${limitedNumbers.slice(6, 8)} ${limitedNumbers.slice(8)}`;
      } else {
        return `${limitedNumbers.slice(0, 4)}-${limitedNumbers.slice(
          4,
          6
        )}-${limitedNumbers.slice(6, 8)} ${limitedNumbers.slice(
          8,
          10
        )}:${limitedNumbers.slice(10)}`;
      }
    };

    const handleSpecialDateTimeChange = (e) => {
      const formattedValue = formatDateTimeInput(e.target.value);
      handleChange({ target: { name: fieldName, value: formattedValue } });
    };

    return (
      <div className="input_2col">
        <input
          type="text"
          name={fieldName}
          placeholder={placeholder}
          value={formData[fieldName] || ""}
          onChange={handleSpecialDateTimeChange}
          maxLength={16} // YYYY-MM-DD HH:MM 형식의 최대 길이
        />
      </div>
    );
  };

  return (
    <section className="vip-form-section">
      <h2 className="section-subtitle">common</h2>

      {/* 기본 정보 섹션 */}
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">기본 정보</h3>

        {/* 뇌손상 종류 - 가장 중요한 필드 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              뇌손상 종류 (index_injury)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "TBI", value: "TBI" },
                  {
                    label: "SAH (ruptured aneurysm)",
                    value: "SAH (ruptured aneurysm)",
                  },
                  {
                    label: "ICH (primary, secondary) / IVH",
                    value: "ICH (primary, secondary) / IVH",
                  },
                  { label: "Ischemic stroke", value: "Ischemic stroke" },
                  { label: "Others", value: "Others" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="index_injury"
                      value={option.value}
                      checked={formData.index_injury === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 뇌손상 종류 메모 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              뇌손상 종류 메모 (index_injury_memo)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="index_injury_memo"
                value={formData.index_injury_memo || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="block-2column" />
        </div>
        {/* 환자번호 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">환자번호 (hos_id)</label>
            <div className="input_2col">
              <input
                type="text"
                name="hos_id"
                value={formData.hos_id || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="block-2column" />
        </div>

        {/* 나이, 성별 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">나이 (age)</label>
            <div className="input_2col">
              <input
                type="text"
                name="age"
                value={formData.age || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">성별 (sex)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["남자", "여자"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="sex"
                      value={opt}
                      checked={formData.sex === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 키, 체중 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">키 (ht)</label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="ht"
                  value={formData.ht || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">cm</span>
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">체중 (wt)</label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="wt"
                  value={formData.wt || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">kg</span>
              </div>
            </div>
          </div>
        </div>

        {/* 병원 코드 - 자동 매핑 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">병원 (hospital)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["A", "B", "C", "D", "E", "F", "G", "H", "I"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hospital"
                      value={opt}
                      checked={formData.hospital === opt}
                      onChange={handleChange}
                      disabled={true}
                      style={{ cursor: "not-allowed" }}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              마지막 정상 확인 일시 (last_normal_dt)
            </label>
            {renderDateTimeField("last_normal_dt")}
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              증상 발생 일시 (symptom_onset_dt)
            </label>
            {renderDateTimeField("symptom_onset_dt")}
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              응급실 방문 일시 (arrival_dt)
            </label>
            {renderDateTimeField("arrival_dt")}
          </div>
          <div className="block-2column" />
        </div>

        {/* 전원여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">전원여부 (arrival_from)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Direct", value: "Direct" },
                  { label: "Other hospital", value: "Other hospital" },
                  { label: "In-hospital", value: "In-hospital" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_from"
                      value={option.value}
                      checked={formData.arrival_from === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 호흡수: 인공 호흡여부 (arrival_rr_unk)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Spontaneous", value: "Spontaneous" },
                  { label: "Ventilated", value: "Ventilated" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_rr_unk"
                      value={option.value}
                      checked={formData.arrival_rr_unk === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ABC 평가 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 Airway (arrival_airway)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Clear", value: "Clear" },
                  { label: "Obstructed", value: "Obstructed" },
                  { label: "Adjunctive Airway", value: "Adjunctive Airway" },
                  { label: "Intubated", value: "Intubated" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_airway"
                      value={option.value}
                      checked={formData.arrival_airway === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 breathing (arrival_breathing)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label: "Spontaneous, adequate",
                    value: "Spontaneous, adequate",
                  },
                  {
                    label: "Spontaneous, insufficient",
                    value: "Spontaneous, insufficient",
                  },
                  {
                    label: "Manual support with bag, valve, mask",
                    value: "Manual support with bag, valve, mask",
                  },
                  {
                    label: "Mechanical ventilation",
                    value: "Mechanical ventilation",
                  },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_breathing"
                      value={option.value}
                      checked={formData.arrival_breathing === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 Circulation (arrival_circulation)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label: "No specific therapy",
                    value: "No specific therapy",
                  },
                  { label: "IV Fluids", value: "IV Fluids" },
                  { label: "Vasopressors", value: "Vasopressors" },
                  { label: "CPR", value: "CPR" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_circulation"
                      value={option.value}
                      checked={formData.arrival_circulation === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 수축기혈압 (arrival_sbp)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_sbp"
                  value={formData.arrival_sbp || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">mmHg</span>
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 이완기혈압 (arrival_dbp)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_dbp"
                  value={formData.arrival_dbp || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">mmHg</span>
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 심박수 (arrival_hr)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_hr"
                  value={formData.arrival_hr || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">bpm</span>
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 체온 (arrival_temp)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_temp"
                  value={formData.arrival_temp || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">°C</span>
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 호흡수 (arrival_rr)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="arrival_rr"
                value={formData.arrival_rr || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ER 도착시 산소포화도 (arrival_spo2)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_spo2"
                  value={formData.arrival_spo2 || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GCS 평가 섹션 */}
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">Glasgow Coma Scale (GCS) 평가</h3>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 GCS_Eye (arrival_gcs_e)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  { label: "2 : To pain", value: "2 : To pain" },
                  { label: "3 : To speech", value: "3 : To speech" },
                  { label: "4 : Spontaneously", value: "4 : Spontaneously" },
                  {
                    label: "Untestable (swollen)",
                    value: "0 : Untestable (swollen)",
                  },
                  {
                    label: "Untestable (other)",
                    value: "0 : Untestable (other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_gcs_e"
                      value={option.value}
                      checked={formData.arrival_gcs_e === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 GCS_Verbal (arrival_gcs_v)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  {
                    label: "2 : Incomprehensible sound",
                    value: "2 : Incomprehensible sound",
                  },
                  {
                    label: "3 : Inappropriate words",
                    value: "3 : Inappropriate words",
                  },
                  { label: "4 : Confused", value: "4 : Confused" },
                  { label: "5 : Oriented", value: "5 : Oriented" },
                  {
                    label: "Untestable (tracheotomy/endotracheal tube)",
                    value: "0 : Untestable (tracheotomy/endotracheal tube)",
                  },
                  {
                    label: "Untestable (Other)",
                    value: "0 : Untestable (Other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_gcs_v"
                      value={option.value}
                      checked={formData.arrival_gcs_v === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 GCS_Motor (arrival_gcs_m)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  {
                    label: "2 : Abnormal extension",
                    value: "2 : Abnormal extension",
                  },
                  {
                    label: "3 : Abnormal flexion",
                    value: "3 : Abnormal flexion",
                  },
                  {
                    label: "4 : Normal flexion/withdrawal",
                    value: "4 : Normal flexion/withdrawal",
                  },
                  {
                    label: "5 : Localizes to pain",
                    value: "5 : Localizes to pain",
                  },
                  {
                    label: "6 : Obeys command",
                    value: "6 : Obeys command",
                  },
                  {
                    label: "Untestable (Deep sedation/paralyzed)",
                    value: "0 : Untestable (Deep sedation/paralyzed)",
                  },
                  {
                    label: " Untestable (Other)",
                    value: "0 :  Untestable (Other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_gcs_m"
                      value={option.value}
                      checked={formData.arrival_gcs_m === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              GCS 측정시 상황 (arrival_gcs_confounder)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "GCS Accurate", value: "GCS Accurate" },
                  {
                    label: "Alcohol/drugs of abuse",
                    value: "Alcohol/drugs of abuse",
                  },
                  { label: "C-spine injury", value: "C-spine injury" },
                  {
                    label: "Hypoxia/hypotension",
                    value: "Hypoxia/hypotension",
                  },
                  { label: "Hypothermia", value: "Hypothermia" },
                  { label: "Sedation", value: "Sedation" },
                  { label: "Paralytic", value: "Paralytic" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_gcs_confounder"
                      value={option.value}
                      checked={formData.arrival_gcs_confounder === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "12px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">
              내원 후 첫 GCS 총점 (arrival_gcs_total)
              <span className="tooltip-container">
                <span className="tooltip-icon">?</span>
                <span className="tooltip-text">
                  【GCS Total Score 자동계산 공식】
                  <br />
                  <br />
                  ★ 필수 입력 필드 (3개):
                  <br />
                  • arrival_gcs_e (Eye 반응)
                  <br />
                  • arrival_gcs_v (Verbal 반응)
                  <br />
                  • arrival_gcs_m (Motor 반응)
                  <br />
                  <br />
                  ★ 계산 로직:
                  <br />
                  1) E=0 또는 M=0인 경우
                  <br />
                  &nbsp;&nbsp;&nbsp;→ 총점 0점 (Untestable/Unknown)
                  <br />
                  <br />
                  2) V=0인 경우 (기관삽관 등):
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) ≤6: +1점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) =7: +2점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) 8-9: +4점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) =10: +5점
                  <br />
                  <br />
                  3) 그 외의 경우:
                  <br />
                  &nbsp;&nbsp;&nbsp;→ E + V + M 단순 합산
                  <br />
                  <br />★ 점수 범위: 0~15점
                </span>
              </span>
            </label>
            <div className="input_1col">
              <input
                type="text"
                name="arrival_gcs_total"
                value={formData.arrival_gcs_total || ""}
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                  fontWeight: "bold",
                  color: "#007bff",
                }}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 pupil size, Rt (arrival_pupil_size_rt)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_pupil_size_rt"
                  value={formData.arrival_pupil_size_rt || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">mm</span>
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 pupil size, Lt (arrival_pupil_size_lt)
            </label>
            <div className="input_2col">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  name="arrival_pupil_size_lt"
                  value={formData.arrival_pupil_size_lt || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">mm</span>
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 pupil response, Rt (arrival_pupil_react_rt)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "+ (Brisk)", value: "(Brisk) +" },
                  { label: "+ (Sluggish)", value: "(Sluggish) +" },
                  { label: "- (Negative)", value: "(Negative) -" },
                  { label: "Untestable", value: "Untestable" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_pupil_react_rt"
                      value={option.value}
                      checked={formData.arrival_pupil_react_rt === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              내원 후 첫 pupil response, Lt (arrival_pupil_react_lt)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "+ (Brisk)", value: "(Brisk) +" },
                  { label: "+ (Sluggish)", value: "(Sluggish) +" },
                  { label: "- (Negative)", value: "(Negative) -" },
                  { label: "Untestable", value: "Untestable" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_pupil_react_lt"
                      value={option.value}
                      checked={formData.arrival_pupil_react_lt === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              초기 (ER or In-hospital) Pupillometer 시행 여부
              (arrival_pupillometer_yn)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="arrival_pupillometer_yn"
                      value={option.value}
                      checked={
                        formData.arrival_pupillometer_yn === option.value
                      }
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              응급실에서 촬영한 영상 (모두 선택) (arrival_image)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label: "Noncontrast CT Brain",
                    value: "Noncontrast CT Brain",
                  },
                  { label: "CT Angio", value: "CT Angio" },
                  { label: "CT perfusion", value: "CT perfusion" },
                  { label: "MRI", value: "MRI" },
                  { label: "TFCA", value: "TFCA" },
                ].map((option) => (
                  <label key={option.value} className="checkbox-label">
                    <input
                      type="checkbox"
                      name="arrival_image"
                      value={option.value}
                      checked={
                        Array.isArray(formData.arrival_image) &&
                        formData.arrival_image.includes(option.value)
                      }
                      onChange={handleCheckboxChange}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              응급실에서 촬영한 최초 영상 시각 (arrival_image_dt)
            </label>
            {renderDateTimeField("arrival_image_dt")}
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">고혈압 유무 (hx_htn)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_htn"
                      value={option.value}
                      checked={formData.hx_htn === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">당뇨병 유무 (hx_dm)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_dm"
                      value={option.value}
                      checked={formData.hx_dm === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              간경화 유무 (hx_cirrhosis)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_cirrhosis"
                      value={option.value}
                      checked={formData.hx_cirrhosis === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">뇌졸중 유무 (hx_stroke)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_stroke"
                      value={option.value}
                      checked={formData.hx_stroke === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              악성종양 유무 (hx_malignancy)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_malignancy"
                      value={option.value}
                      checked={formData.hx_malignancy === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Chronic kidney disease 유무(stage III 이상) (hx_ckd)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_ckd"
                      value={option.value}
                      checked={formData.hx_ckd === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              antiplatelet 복용력 (hx_plt)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_plt"
                      value={option.value}
                      checked={formData.hx_plt === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              anticoagulant 복용력 (hx_coa)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_coa"
                      value={option.value}
                      checked={formData.hx_coa === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              antiplatelet 종류 (hx_plt_type)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Aspirin", value: "Aspirin" },
                  { label: "Clopidogrel", value: "Clopidogrel" },
                  { label: "Prasugrel", value: "Prasugrel" },
                  { label: "Ticagrelor", value: "Ticagrelor" },
                  { label: "Cangrelor", value: "Cangrelor" },
                  { label: "Abciximab", value: "Abciximab" },
                  { label: "Eptifibatide", value: "Eptifibatide" },
                  { label: "Tirofiban", value: "Tirofiban" },
                  { label: "Cilostazol", value: "Cilostazol" },
                  { label: "Dipyridamole", value: "Dipyridamole" },
                ].map((option) => (
                  <label key={option.value} className="checkbox-label">
                    <input
                      type="checkbox"
                      name="hx_plt_type"
                      value={option.value}
                      checked={
                        Array.isArray(formData.hx_plt_type) &&
                        formData.hx_plt_type.includes(option.value)
                      }
                      onChange={handleCheckboxChange}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              anticoagulant 종류 (hx_coa_type)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Warfarin", value: "Warfarin" },
                  { label: "Dabigatran", value: "Dabigatran" },
                  { label: "Argatroban", value: "Argatroban" },
                  { label: "Lepirudin", value: "Lepirudin" },
                  { label: "Rivaroxaban", value: "Rivaroxaban" },
                  { label: "Edoxaban", value: "Edoxaban" },
                  { label: "Heparin", value: "Heparin" },
                  { label: "Enoxaparin", value: "Enoxaparin" },
                  { label: "Dalteparin", value: "Dalteparin" },
                  { label: "Tinzaparin", value: "Tinzaparin" },
                  { label: "Fondaparinux", value: "Fondaparinux" },
                ].map((option) => (
                  <label key={option.value} className="checkbox-label">
                    <input
                      type="checkbox"
                      name="hx_coa_type"
                      value={option.value}
                      checked={
                        Array.isArray(formData.hx_coa_type) &&
                        formData.hx_coa_type.includes(option.value)
                      }
                      onChange={handleCheckboxChange}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">음주력 (hx_alcohol)</label>
            <div className="input_1col">
              <div className="rad-group vertical">
                {[
                  "None",
                  "Infrequent : < 12 drinks/year",
                  "Light : ≥12 drinks/year and ≤3 drinks/week",
                  "Moderate : >3 and ≤ 14 drinks/week(male), >3 and ≤ 7 drinks/week(Female)",
                  "Heavy : >14 drinks/week (Male), >7 drinks/week (Female)",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_alcohol"
                      value={opt}
                      checked={formData.hx_alcohol === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "12px" }}>
                      {opt}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">흡연력 (hx_smok)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["Never", "Current", "Ex-smoker"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_smok"
                      value={opt}
                      checked={formData.hx_smok === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">흡연 갑년 (hx_smok_pyrs)</label>
            <div className="input_2col">
              <input
                type="text"
                name="hx_smok_pyrs"
                value={formData.hx_smok_pyrs || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">
              병전 mRS 점수 (hx_pre_mrs)
            </label>
            <div className="input_1col">
              <div className="rad-group vertical">
                {[
                  "0 : No symptoms",
                  "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
                  "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
                  "3 : Moderate disability. Requires some help, but able to walk unassisted.",
                  "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted.",
                  "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent.",
                  "6 : Dead.",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="hx_pre_mrs"
                      value={opt}
                      checked={formData.hx_pre_mrs === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {opt}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 조건부 필드들 - SAH 관련 */}
      {formData.index_injury === "SAH (ruptured aneurysm)" && (
        <div className="basic-info-fieldset">
          <h3 className="section-subtitle" style={{ color: "#dc3545" }}>
            SAH
          </h3>

          {/* WFNS, Fisher, Hunt Hess 스케일 */}
          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">WFNS score (sah_wfns)</label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    {
                      label: "Grade 1: GCS score of 15 without focal deficit",
                      value: "Grade 1: GCS score of 15 without focal deficit",
                    },
                    {
                      label:
                        "Grade 2: GCS score of 13 or 14 without focal deficit",
                      value:
                        "Grade 2: GCS score of 13 or 14 without focal deficit",
                    },
                    {
                      label:
                        "Grade 3: GCS score of 13 or 14 with focal deficit",
                      value:
                        "Grade 3: GCS score of 13 or 14 with focal deficit",
                    },
                    {
                      label: "Grade 4: GCS score of 7-12",
                      value: "Grade 4: GCS score of 7-12",
                    },
                    {
                      label: "Grade 5: GCS score of 3-6",
                      value: "Grade 5: GCS score of 3-6",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_wfns"
                        value={option.value}
                        checked={formData.sah_wfns === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "13px" }}>
                        {option.label}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                modified Fisher scale (sah_modified_fisher)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : no SAH or IVH", value: "0 : no SAH or IVH" },
                    {
                      label: "1 : SAH less than 1mm thick",
                      value: "1 : SAH less than 1mm thick",
                    },
                    {
                      label: "2 : SAH less than 1mm thick + IVH",
                      value: "2 : SAH less than 1mm thick + IVH",
                    },
                    {
                      label: "3 : SAH more than 1mm thick,+ no IVH",
                      value: "3 : SAH more than 1mm thick,+ no IVH",
                    },
                    {
                      label: "4 : SAH more than 1mm thick + IVH",
                      value: "4 : SAH more than 1mm thick + IVH",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_modified_fisher"
                        value={option.value}
                        checked={formData.sah_modified_fisher === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "13px" }}>
                        {option.label}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Hunt Hess scale */}
          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Hunt Hess scale (sah_hh)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    {
                      label:
                        "1 : Mild Headache, Alert and Oriented, Minimal (if any) Nuchal Rigidity",
                      value:
                        "1 : Mild Headache, Alert and Oriented, Minimal (if any) Nuchal Rigidity",
                    },
                    {
                      label:
                        "2 : Full Nuchal Rigidity, Moderate-Severe Headache, Alert and Oriented, No Neuro Deficit (Besides CN Palsy)",
                      value:
                        "2 : Full Nuchal Rigidity, Moderate-Severe Headache, Alert and Oriented, No Neuro Deficit (Besides CN Palsy)",
                    },
                    {
                      label:
                        "3 : Lethargy or Confusion, Mild Focal Neurological Deficits",
                      value:
                        "3 : Lethargy or Confusion, Mild Focal Neurological Deficits",
                    },
                    {
                      label: "4 : Stuporous, More Severe Focal Deficit",
                      value: "4 : Stuporous, More Severe Focal Deficit",
                    },
                    {
                      label:
                        "5 : Comatose, showing signs of severe neurological impairment (ex: posturing)",
                      value:
                        "5 : Comatose, showing signs of severe neurological impairment (ex: posturing)",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_hh"
                        value={option.value}
                        checked={formData.sah_hh === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "13px" }}>
                        {option.label}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Ruptured aneurysm 여부 (sah_aneurysmal)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_aneurysmal"
                        value={option.value}
                        checked={formData.sah_aneurysmal === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Ruptured aneurysm에 의한 ICH가 동반된 경우 (sah_ich)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_ich"
                        value={option.value}
                        checked={formData.sah_ich === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                SAH의 기타 원인 (sah_others)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_others"
                  value={formData.sah_others}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="block-2column" />
          </div>

          {/* SAH 원인 및 ICH 관련 */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH의 위치 (sah_ich_location)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Frontal", value: "Frontal" },
                    { label: "Bifrontal", value: "Bifrontal" },
                    { label: "Frontotemporal", value: "Frontotemporal" },
                    { label: "Temporal", value: "Temporal" },
                    { label: "Other", value: "Other" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_ich_location"
                        value={option.value}
                        checked={formData.sah_ich_location === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                ICH 기타 위치 (sah_ich_location_other)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_ich_location_other"
                  value={formData.sah_ich_location_other}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Ruptured aneurysm에 의한 ICH의 volume (sah_ich_volume)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_ich_volume"
                  value={formData.sah_ich_volume}
                  onChange={handleChange}
                />
                <span className="unit-text">ml</span>
              </div>
            </div>

            <div className="block-2column" />
          </div>

          {/* 동맥류 위치 정보 */}
          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                ruptured aneurysm location (aneurysm_location)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "Cavernous", value: "Cavernous" },
                    {
                      label: "Persistent trigeminal",
                      value: "Persistent trigeminal",
                    },
                    {
                      label: "Medial paraclinoid",
                      value: "Medial paraclinoid",
                    },
                    {
                      label: "Lateral paraclinoid",
                      value: "Lateral paraclinoid",
                    },
                    { label: "Ophthalmic", value: "Ophthalmic" },
                    {
                      label: "Superior hypophyseal",
                      value: "Superior hypophyseal",
                    },
                    {
                      label: "Posterior communicating",
                      value: "Posterior communicating",
                    },
                    {
                      label: "Anterior choroidal",
                      value: "Anterior choroidal",
                    },
                    {
                      label: "Internal carotid artery bifurcation",
                      value: "Internal carotid artery bifurcation",
                    },
                    {
                      label: "Middle cerebral artery bifurcation",
                      value: "Middle cerebral artery bifurcation",
                    },
                    {
                      label: "Anterior communicating",
                      value: "Anterior communicating",
                    },
                    { label: "Pericallosal", value: "Pericallosal" },
                    {
                      label: "Posterior inferior cerebellar artery",
                      value: "Posterior inferior cerebellar artery",
                    },
                    {
                      label: "Superior cerebellar",
                      value: "Superior cerebellar",
                    },
                    { label: "Basilar apex", value: "Basilar apex" },
                    { label: "Other", value: "Other" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="aneurysm_location"
                        value={option.value}
                        checked={formData.aneurysm_location === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "13px" }}>
                        {option.label}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ruptured aneurysm의 location_기타 (aneurysm_location_other)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="aneurysm_location_other"
                  value={formData.aneurysm_location_other}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                aneurysm height (aneurysm_height)
              </label>
              <div className="input_2col">
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="aneurysm_height"
                    value={formData.aneurysm_height || ""}
                    onChange={handleChange}
                  />
                  <span className="unit-text">mm</span>
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                aneurysm width (aneurysm_width)
              </label>
              <div className="input_2col">
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="aneurysm_width"
                    value={formData.aneurysm_width || ""}
                    onChange={handleChange}
                  />
                  <span className="unit-text">mm</span>
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                aneurysm diameter (aneurysm_diameter)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="aneurysm_diameter"
                  value={formData.aneurysm_diameter}
                  onChange={handleChange}
                />
                <span className="unit-text">mm</span>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                neck (aneurysm_neck_max)
              </label>
              <div className="input_2col">
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="aneurysm_neck_max"
                    value={formData.aneurysm_neck_max || ""}
                    onChange={handleChange}
                  />
                  <span className="unit-text">mm</span>
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                aspect ratio value (aneurysm_aspect_ratio)
                <span className="tooltip-container">
                  <span className="tooltip-icon">?</span>
                  <span className="tooltip-text">
                    【Aneurysm Aspect Ratio 자동계산 공식】
                    <br />
                    <br />
                    ★ 필수 입력 필드 (2개):
                    <br />
                    • aneurysm_height (동맥류 높이, mm)
                    <br />
                    • aneurysm_neck_max (목 최대치, mm)
                    <br />
                    <br />
                    ★ 계산 공식:
                    <br />
                    Aspect Ratio = height ÷ neck_max
                    <br />
                    <br />
                    ★ 예시:
                    <br />
                    height=8mm, neck=4mm
                    <br />
                    → 8 ÷ 4 = 2.00
                    <br />
                    <br />
                    ★ 소수점 2자리까지 표시
                    <br />★ neck_max가 0이거나 빈값이면 계산 안됨
                  </span>
                </span>
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="aneurysm_aspect_ratio"
                  value={formData.aneurysm_aspect_ratio || ""}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Bottleneck factor (aneurysm_bottleneck_factor)
                <span className="tooltip-container">
                  <span className="tooltip-icon">?</span>
                  <span className="tooltip-text">
                    【Aneurysm Bottleneck Factor 자동계산 공식】
                    <br />
                    <br />
                    ★ 필수 입력 필드 (2개):
                    <br />
                    • aneurysm_width (동맥류 너비, mm)
                    <br />
                    • aneurysm_neck_max (목 최대치, mm)
                    <br />
                    <br />
                    ★ 계산 공식:
                    <br />
                    Bottleneck Factor = width ÷ neck_max
                    <br />
                    <br />
                    ★ 예시:
                    <br />
                    width=6mm, neck=3mm
                    <br />
                    → 6 ÷ 3 = 2.00
                    <br />
                    <br />
                    ★ 소수점 2자리까지 표시
                    <br />★ neck_max가 0이거나 빈값이면 계산 안됨
                  </span>
                </span>
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="aneurysm_bottleneck_factor"
                  value={formData.aneurysm_bottleneck_factor || ""}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                aneurysm shape/pathology (aneurysm_shape_pathology)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Saccular", value: "Saccular" },
                    { label: "Dissecting", value: "Dissecting" },
                    { label: "Fusiform", value: "Fusiform" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="aneurysm_shape_pathology"
                        value={option.value}
                        checked={
                          formData.aneurysm_shape_pathology === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                aneurysm laterality (aneurysm_laterality)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Left", value: "Left" },
                    { label: "Right", value: "Right" },
                    { label: "Midline", value: "Midline" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="aneurysm_laterality"
                        value={option.value}
                        checked={formData.aneurysm_laterality === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                morphology type (aneurysm_morphology_type)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Regular", value: "Regular" },
                    {
                      label: "Daughter-sac, multi-lobed aneurysm",
                      value: "Daughter-sac, multi-lobed aneurysm",
                    },
                    { label: "Bleb", value: "Bleb" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="aneurysm_morphology_type"
                        value={option.value}
                        checked={
                          formData.aneurysm_morphology_type === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column" />
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Number of UIA (aneurysm_unruptured_number)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="aneurysm_unruptured_number"
                  value={formData.aneurysm_unruptured_number}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* 수술적 치료 섹션 */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Status of surgical intervention (sah_aneurysm_surg)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                    { label: "Attempt failed", value: "Attempt failed" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_aneurysm_surg"
                        value={option.value}
                        checked={formData.sah_aneurysm_surg === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                수술적 치료 종류 (sah_aneurysm_surg_type)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Bypass", value: "Bypass" },
                    { label: "Clipping", value: "Clipping" },
                    { label: "Trapping alone", value: "Trapping alone" },
                    { label: "Wrapping", value: "Wrapping" },
                    {
                      label: "Hunterian ligation alone",
                      value: "Hunterian ligation alone",
                    },
                    { label: "Other", value: "Other" },
                    { label: "None/attempted", value: "None/attempted" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_aneurysm_surg_type"
                        value={option.value}
                        checked={
                          formData.sah_aneurysm_surg_type === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-2column">
              <label className="item_title_2col">
                수술적 치료 종류_기타 (sah_aneurysm_surg_other)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_aneurysm_surg_other"
                  value={formData.sah_aneurysm_surg_other || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                수술 시작 시각 (sah_aneurysm_surg_start_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_aneurysm_surg_start_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_aneurysm_surg_start_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_aneurysm_surg_start_dt) || "")
                        .length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_aneurysm_surg_start_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_aneurysm_surg_start_dt")}
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                수술 종료 시각 (sah_aneurysm_surg_end_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_aneurysm_surg_end_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_aneurysm_surg_end_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_aneurysm_surg_end_dt) || "")
                        .length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_aneurysm_surg_end_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_aneurysm_surg_end_dt")}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                수술적 치료 관련 중대한 합병증 (sah_aneurysm_surg_comp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "None" },
                    {
                      label:
                        "Vessel compromise (significant stenosis > 50%, occlusion)",
                      value:
                        "Vessel compromise (significant stenosis > 50%, occlusion)",
                    },
                    { label: "Distal embolism", value: "Distal embolism" },
                    {
                      label: "Incomplete clipping",
                      value: "Incomplete clipping",
                    },
                    {
                      label:
                        "Craniotomy related complication _ extradural or subdural hematoma",
                      value:
                        "Craniotomy related complication _ extradural or subdural hematoma",
                    },
                    {
                      label: "Cranial nerve injury",
                      value: "Cranial nerve injury",
                    },
                    {
                      label: "Direct brain tissue injury",
                      value: "Direct brain tissue injury",
                    },
                    { label: "Others, specify", value: "Others, specify" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_aneurysm_surg_comp"
                        value={option.value}
                        checked={
                          formData.sah_aneurysm_surg_comp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "13px" }}>
                        {option.label}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column" />
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                수술적 치료 관련 중대한 합병증_기타
                (sah_aneurysm_surg_comp_other)
              </label>
              <div className="input_1col">
                <input
                  type="text"
                  name="sah_aneurysm_surg_comp_other"
                  value={formData.sah_aneurysm_surg_comp_other || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* 혈관내 치료 섹션 */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Status of endovascular intervention (sah_aneurysm_endo)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                    { label: "Attempt failed", value: "Attempt failed" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_aneurysm_endo"
                        value={option.value}
                        checked={formData.sah_aneurysm_endo === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                혈관내 치료 종류 (sah_aneurysm_endo_type)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Coil", value: "Coil" },
                    {
                      label: "Coil with balloon remodeling",
                      value: "Coil with balloon remodeling",
                    },
                    { label: "Stent only", value: "Stent only" },
                    { label: "Stent/coil", value: "Stent/coil" },
                    { label: "Vessel occlusion", value: "Vessel occlusion" },
                    { label: "Flow diverter", value: "Flow diverter" },
                    { label: "Other", value: "Other" },
                    { label: "None/attempted", value: "None/attempted" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_aneurysm_endo_type"
                        value={option.value}
                        checked={
                          formData.sah_aneurysm_endo_type === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                혈관내 치료 종류_기타 (sah_aneurysm_endo_type_other)
              </label>
              <div className="input_1col">
                <input
                  type="text"
                  name="sah_aneurysm_endo_type_other"
                  value={formData.sah_aneurysm_endo_type_other || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                혈관내 치료 시작 시각 (sah_aneurysm_endo_start_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_aneurysm_endo_start_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_aneurysm_endo_start_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_aneurysm_endo_start_dt) || "")
                        .length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_aneurysm_endo_start_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_aneurysm_endo_start_dt")}
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                혈관내 치료 종료 시각 (sah_aneurysm_endo_end_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_aneurysm_endo_end_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_aneurysm_endo_end_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_aneurysm_endo_end_dt) || "")
                        .length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_aneurysm_endo_end_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_aneurysm_endo_end_dt")}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                혈관내 치료 관련 중대한 합병증 (sah_aneurysm_endo_comp)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "None" },
                    {
                      label: "Ischemia (thrombosis / vessel occlusion)",
                      value: "Ischemia (thrombosis / vessel occlusion)",
                    },
                    {
                      label: "Procedural rupture",
                      value: "Procedural rupture",
                    },
                    { label: "Device migration", value: "Device migration" },
                    { label: "Others, Specify", value: "Others@ Specify" },
                  ].map((option) => (
                    <label key={option.value} className="checkbox-label">
                      <input
                        type="checkbox"
                        name="sah_aneurysm_endo_comp"
                        value={option.value}
                        checked={
                          Array.isArray(formData.sah_aneurysm_endo_comp) &&
                          formData.sah_aneurysm_endo_comp.includes(option.value)
                        }
                        onChange={handleCheckboxChange}
                      />
                      <span style={{ fontSize: "15px" }}>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                혈관내 치료 관련 중대한 합병증_기타
                (sah_aneurysm_endo_comp_others)
              </label>
              <div className="input_1col">
                <input
                  type="text"
                  name="sah_aneurysm_endo_comp_others"
                  value={formData.sah_aneurysm_endo_comp_others || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* CSF drainage 섹션 */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                EVD 혹은 Lumbar drain 여부 (sah_csf_diversion)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "EVD", value: "EVD" },
                    { label: "Lumbar drain", value: "Lumbar drain" },
                    { label: "Both", value: "Both" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_csf_diversion"
                        value={option.value}
                        checked={formData.sah_csf_diversion === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column" />
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                EVD 혹은 Lumbar drain 삽입 시각 (sah_csf_diversion_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_csf_diversion_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_csf_diversion_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_csf_diversion_dt) || "").length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_csf_diversion_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_csf_diversion_dt")}
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                EVD 혹은 Lumbar drain 제거 시각 (sah_csf_removal_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_csf_removal_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_csf_removal_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_csf_removal_dt) || "").length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_csf_removal_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_csf_removal_dt")}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Rebleeding 여부 (sah_rebleeding)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_rebleeding"
                        value={option.value}
                        checked={formData.sah_rebleeding === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Rebleeding 발생 일시 (sah_rebleeding_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="sah_rebleeding_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.sah_rebleeding_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.sah_rebleeding_dt) || "").length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "sah_rebleeding_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "sah_rebleeding_dt")}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-2column">
              <label className="item_title_2col">
                Acute hydrocephalus 여부 (sah_hcp_acute)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                    { label: "Indeterminate", value: "Indeterminate" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="sah_hcp_acute"
                        value={option.value}
                        checked={formData.sah_hcp_acute === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 조건부 필드들 - TBI 관련 */}
      {formData.index_injury === "TBI" && (
        <div className="basic-info-fieldset">
          <h3 className="section-subtitle" style={{ color: "#fd7e14" }}>
            TBI
          </h3>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                TBI injury type (tbi_injury_type)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    "Ground level fall (낙상)",
                    "Fall from height > 1 meter (추락)",
                    "Road traffic accident",
                    "Violence/Assault",
                    "Others, specify",
                    "Unknown",
                  ].map((opt) => (
                    <label key={opt} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_injury_type"
                        value={opt}
                        checked={formData.tbi_injury_type === opt}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "12px" }}>
                        {opt}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                TBI injury type_기타 (tbi_injury_type_others)
              </label>
              <div className="input_1col">
                <input
                  type="text"
                  name="tbi_injury_type_others"
                  value={formData.tbi_injury_type_others || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Head and neck worst injury? (tbi_iss_headneck)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : No Injury", value: "0 : No Injury" },
                    {
                      label: "1 : Minor- no treatment needed",
                      value: "1 : Minor- no treatment needed",
                    },
                    {
                      label: "2 : Moderate - requires only outpatient teatment",
                      value: "2 : Moderate - requires only outpatient teatment",
                    },
                    {
                      label:
                        "3 : Serious - requires non-ICU hospital admission",
                      value:
                        "3 : Serious - requires non-ICU hospital admission",
                    },
                    {
                      label:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                      value:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                    },
                    {
                      label:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                      value:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                    },
                    {
                      label: "6 : Unsurvivable - not survivable",
                      value: "6 : Unsurvivable - not survivable",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_iss_headneck"
                        value={option.value}
                        checked={formData.tbi_iss_headneck === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Face worst injury? (tbi_iss_face)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : No Injury", value: "0 : No Injury" },
                    {
                      label: "1 : Minor- no treatment needed",
                      value: "1 : Minor- no treatment needed",
                    },
                    {
                      label: "2 : Moderate - requires only outpatient teatment",
                      value: "2 : Moderate - requires only outpatient teatment",
                    },
                    {
                      label:
                        "3 : Serious - requires non-ICU hospital admission",
                      value:
                        "3 : Serious - requires non-ICU hospital admission",
                    },
                    {
                      label:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                      value:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                    },
                    {
                      label:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                      value:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                    },
                    {
                      label: "6 : Unsurvivable - not survivable",
                      value: "6 : Unsurvivable - not survivable",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_iss_face"
                        value={option.value}
                        checked={formData.tbi_iss_face === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Chest worst injury? (tbi_iss_chest)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : No Injury", value: "0 : No Injury" },
                    {
                      label: "1 : Minor- no treatment needed",
                      value: "1 : Minor- no treatment needed",
                    },
                    {
                      label: "2 : Moderate - requires only outpatient teatment",
                      value: "2 : Moderate - requires only outpatient teatment",
                    },
                    {
                      label:
                        "3 : Serious - requires non-ICU hospital admission",
                      value:
                        "3 : Serious - requires non-ICU hospital admission",
                    },
                    {
                      label:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                      value:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                    },
                    {
                      label:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                      value:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                    },
                    {
                      label: "6 : Unsurvivable - not survivable",
                      value: "6 : Unsurvivable - not survivable",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_iss_chest"
                        value={option.value}
                        checked={formData.tbi_iss_chest === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Abdomen worst injury? (tbi_iss_abdomen)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : No Injury", value: "0 : No Injury" },
                    {
                      label: "1 : Minor- no treatment needed",
                      value: "1 : Minor- no treatment needed",
                    },
                    {
                      label: "2 : Moderate - requires only outpatient teatment",
                      value: "2 : Moderate - requires only outpatient teatment",
                    },
                    {
                      label:
                        "3 : Serious - requires non-ICU hospital admission",
                      value:
                        "3 : Serious - requires non-ICU hospital admission",
                    },
                    {
                      label:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                      value:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                    },
                    {
                      label:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                      value:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                    },
                    {
                      label: "6 : Unsurvivable - not survivable",
                      value: "6 : Unsurvivable - not survivable",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_iss_abdomen"
                        value={option.value}
                        checked={formData.tbi_iss_abdomen === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                External worst injury? (tbi_iss_external)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : No Injury", value: "0 : No Injury" },
                    {
                      label: "1 : Minor- no treatment needed",
                      value: "1 : Minor- no treatment needed",
                    },
                    {
                      label: "2 : Moderate - requires only outpatient teatment",
                      value: "2 : Moderate - requires only outpatient teatment",
                    },
                    {
                      label:
                        "3 : Serious - requires non-ICU hospital admission",
                      value:
                        "3 : Serious - requires non-ICU hospital admission",
                    },
                    {
                      label:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                      value:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                    },
                    {
                      label:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                      value:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                    },
                    {
                      label: "6 : Unsurvivable - not survivable",
                      value: "6 : Unsurvivable - not survivable",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_iss_external"
                        value={option.value}
                        checked={formData.tbi_iss_external === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Extremities worst injury? (tbi_iss_extremities)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    { label: "0 : No Injury", value: "0 : No Injury" },
                    {
                      label: "1 : Minor- no treatment needed",
                      value: "1 : Minor- no treatment needed",
                    },
                    {
                      label: "2 : Moderate - requires only outpatient teatment",
                      value: "2 : Moderate - requires only outpatient teatment",
                    },
                    {
                      label:
                        "3 : Serious - requires non-ICU hospital admission",
                      value:
                        "3 : Serious - requires non-ICU hospital admission",
                    },
                    {
                      label:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                      value:
                        "4 : Severe - requires ICU observation and/or basic treatment",
                    },
                    {
                      label:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                      value:
                        "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
                    },
                    {
                      label: "6 : Unsurvivable - not survivable",
                      value: "6 : Unsurvivable - not survivable",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_iss_extremities"
                        value={option.value}
                        checked={formData.tbi_iss_extremities === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Injury severity score (tbi_iss_score)
                <span className="tooltip-container">
                  <span className="tooltip-icon">?</span>
                  <span className="tooltip-text">
                    【ISS (Injury Severity Score) 자동계산 공식】
                    <br />
                    <br />
                    ★ 필수 입력 필드 (6개):
                    <br />
                    • tbi_iss_headneck (머리목 최대손상)
                    <br />
                    • tbi_iss_face (얼굴 최대손상)
                    <br />
                    • tbi_iss_chest (가슴 최대손상)
                    <br />
                    • tbi_iss_abdomen (복부 최대손상)
                    <br />
                    • tbi_iss_external (외부 최대손상)
                    <br />
                    • tbi_iss_extremities (사지 최대손상)
                    <br />
                    <br />
                    ★ 계산 로직:
                    <br />
                    1) 어느 필드든 6점(Unsurvivable)이 있으면
                    <br />
                    &nbsp;&nbsp;&nbsp;→ 무조건 75점
                    <br />
                    <br />
                    2) 6점이 없으면
                    <br />
                    &nbsp;&nbsp;&nbsp;→ 최고점수² + 두번째점수²
                    <br />
                    &nbsp;&nbsp;&nbsp;→ 예: 5점,4점,3점,2점,1점,0점이면
                    <br />
                    &nbsp;&nbsp;&nbsp;→ 5² + 4² = 25 + 16 = 41점
                    <br />
                    <br />★ 점수 범위: 0~75점
                  </span>
                </span>
              </label>
              <div className="input_1col">
                <input
                  type="text"
                  name="tbi_iss_score"
                  value={formData.tbi_iss_score || ""}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Epidural hematoma status (tbi_edh)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "0 : Absent" },
                    { label: "Present", value: "1 : Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_edh"
                        value={option.value}
                        checked={formData.tbi_edh === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Subdural hematoma acute status (tbi_sdh_acute)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_sdh_acute"
                        value={option.value}
                        checked={formData.tbi_sdh_acute === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Subdural hematoma subacute chronic indicator (tbi_sdh_suba_chr)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_sdh_suba_chr"
                        value={option.value}
                        checked={formData.tbi_sdh_suba_chr === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Subdural hematoma mixed density CSF-like collection indicator
                (tbi_mix_dense_csf)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_mix_dense_csf"
                        value={option.value}
                        checked={formData.tbi_mix_dense_csf === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Subarachnoid hemorrhage indicator (tbi_sah)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "0 : Absent" },
                    { label: "Present", value: "1 : Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_sah"
                        value={option.value}
                        checked={formData.tbi_sah === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Type of distribution of the subarachnoid hemorrhage (SAH).
                (tbi_sah_extent)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Diffuse", value: "Diffuse" },
                    { label: "Focal", value: "Focal" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_sah_extent"
                        value={option.value}
                        checked={formData.tbi_sah_extent === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Skull fracture status (tbi_skull_fx)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_skull_fx"
                        value={option.value}
                        checked={formData.tbi_skull_fx === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Midline shift supratentorial indicator (tbi_midline_shift)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_midline_shift"
                        value={option.value}
                        checked={formData.tbi_midline_shift === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                midline shift (tbi_midline_shift_mm)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="tbi_midline_shift_mm"
                  value={formData.tbi_midline_shift_mm || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">mm</span>
              </div>
            </div>

            <div className="block-2column"></div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Basal cisternal compression status (tbi_cistern_comp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Normal", value: "0 : Normal" },
                    { label: "Compressed", value: "1 : Compressed" },
                    { label: "Absent", value: "2 : Absent" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_cistern_comp"
                        value={option.value}
                        checked={formData.tbi_cistern_comp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Ventricle - fourth shift effacement status (tbi_fourth_vent_eff)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_fourth_vent_eff"
                        value={option.value}
                        checked={formData.tbi_fourth_vent_eff === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Contusion status (tbi_contusion)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_contusion"
                        value={option.value}
                        checked={formData.tbi_contusion === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Intracerebral hemorrhage indicator (tbi_ich)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_ich"
                        value={option.value}
                        checked={formData.tbi_ich === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Intraventricular hemorrhage status (tbi_ivh)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "0 : Absent" },
                    { label: "Present", value: "1 : Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_ivh"
                        value={option.value}
                        checked={formData.tbi_ivh === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                Acute hydrocephalus 여부 (tbi_acute_hydro)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_acute_hydro"
                        value={option.value}
                        checked={formData.tbi_acute_hydro === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Diffuse axonal injury status (tbi_dai)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_dai"
                        value={option.value}
                        checked={formData.tbi_dai === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                rotterdam CT score (tbi_rotterdam)
                <span className="tooltip-container">
                  <span className="tooltip-icon">?</span>
                  <span className="tooltip-text">
                    【Rotterdam CT Score 자동계산 공식】
                    <br />
                    = 1 (기본점수) + A + B + C + D<br />
                    <br />
                    A) tbi_cistern_comp (기저조 압박상태):
                    <br />
                    • 0점: Normal
                    <br />
                    • 1점: Compressed
                    <br />
                    • 2점: Absent
                    <br />
                    <br />
                    B) tbi_midline_shift_mm (중선편위):
                    <br />
                    • 0점: ≤5mm
                    <br />
                    • 1점: &gt;5mm
                    <br />
                    <br />
                    C) tbi_edh (경막외혈종):
                    <br />
                    • 0점: Present (있음)
                    <br />
                    • 1점: Absent (없음)
                    <br />
                    <br />
                    D) tbi_sah 또는 tbi_ivh (지주막하출혈/뇌실내출혈):
                    <br />
                    • 0점: 둘 다 Absent
                    <br />
                    • 1점: 둘 중 하나라도 Present
                    <br />
                    <br />★ 최종 점수 범위: 1~6점
                  </span>
                </span>
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="tbi_rotterdam"
                  value={formData.tbi_rotterdam || ""}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Ischemia infarction hypoxic-ischemic injury status
                (tbi_isc_inf_hie)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Absent", value: "Absent" },
                    { label: "Present", value: "Present" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_isc_inf_hie"
                        value={option.value}
                        checked={formData.tbi_isc_inf_hie === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Ischemia infarction hypoxic-ischemic injury extent type
                (tbi_isc_inf_hie_extent)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Focal", value: "Focal" },
                    { label: "Lobar", value: "Lobar" },
                    { label: "Multilobar", value: "Multilobar" },
                    { label: "Hemispheric", value: "Hemispheric" },
                    { label: "Bihemispheric", value: "Bihemispheric" },
                    { label: "Posterior fossa", value: "Posterior fossa" },
                    { label: "Global", value: "Global" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_isc_inf_hie_extent"
                        value={option.value}
                        checked={
                          formData.tbi_isc_inf_hie_extent === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Tranexamic acid 사용 여부 (tbi_txa)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="tbi_txa"
                        value={option.value}
                        checked={formData.tbi_txa === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Tranexamic acid 투약 시각 (tbi_txa_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="tbi_txa_dt"
                  value={dtDisplay(formData.tbi_txa_dt)}
                  onChange={(e) => {
                    const input = e.target.value;

                    // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                    if (
                      input.length <
                      (dtDisplay(formData.tbi_txa_dt) || "").length
                    ) {
                      handleChange(e);
                      return;
                    }

                    // 숫자만 추출
                    const numbers = input.replace(/\D/g, "");

                    if (numbers.length <= 12) {
                      // 최대 12자리 (YYYYMMDDHHmm)
                      let formattedValue = numbers;

                      // 날짜 시간 포맷팅
                      if (numbers.length >= 4) {
                        formattedValue =
                          numbers.slice(0, 4) + "-" + numbers.slice(4);
                      }
                      if (numbers.length >= 6) {
                        formattedValue =
                          formattedValue.slice(0, 7) +
                          "-" +
                          formattedValue.slice(7);
                      }
                      if (numbers.length >= 8) {
                        formattedValue =
                          formattedValue.slice(0, 10) +
                          " " +
                          formattedValue.slice(10);
                      }
                      if (numbers.length >= 10) {
                        formattedValue =
                          formattedValue.slice(0, 13) +
                          ":" +
                          formattedValue.slice(13);
                      }

                      // 원래의 handleChange 함수 호출
                      handleChange({
                        target: {
                          name: "tbi_txa_dt",
                          value: formattedValue,
                        },
                      });
                    }
                  }}
                  onPaste={(e) => handlePaste(e, "tbi_txa_dt")}
                  placeholder="YYYY-MM-DD HH:MM"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 조건부 필드들 - ICH/IVH 관련 */}
      {formData.index_injury === "ICH (primary, secondary) / IVH" && (
        <div className="basic-info-fieldset">
          <h3 className="section-subtitle" style={{ color: "#6f42c1" }}>
            ICH/IVH
          </h3>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">ICH 및 IVH (ich_ivh)</label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {["ICH only", "IVH only", "ICH + IVH"].map((opt) => (
                    <label key={opt} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh"
                        value={opt}
                        checked={formData.ich_ivh === opt}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{opt}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column"></div>
          </div>
          {/* ICH Location */}
          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                ICH의 위치 (ich_location)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    {
                      label: "Lobar / Right (Supratentorial)",
                      value: "Lobar / Right (Supratentorial)",
                    },
                    {
                      label: "Lobar / Left (Supratentorial)",
                      value: "Lobar / Left (Supratentorial)",
                    },
                    {
                      label: "Basal ganglia / Right (Supratentorial)",
                      value: "Basal ganglia / Right (Supratentorial)",
                    },
                    {
                      label: "Basal ganglia / Left (Supratentorial)",
                      value: "Basal ganglia / Left (Supratentorial)",
                    },
                    {
                      label: "Thalamus / Right (Supratentorial)",
                      value: "Thalamus / Right (Supratentorial)",
                    },
                    {
                      label: "Thalamus / Left (Supratentorial)",
                      value: "Thalamus / Left (Supratentorial)",
                    },
                    {
                      label: "Brainstem (Infratentorial)",
                      value: "Brainstem (Infratentorial)",
                    },
                    {
                      label: "Cerebellum (Infratentorial)",
                      value: "Cerebellum (Infratentorial)",
                    },
                    { label: "Others", value: "Others" },
                  ].map((option) => (
                    <label key={option.value} className="checkbox-label">
                      <input
                        type="checkbox"
                        name="ich_location"
                        value={option.value}
                        checked={
                          Array.isArray(formData.ich_location) &&
                          formData.ich_location.includes(option.value)
                        }
                        onChange={handleCheckboxChange}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH의 위치_others (ich_location_others)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_location_others"
                  value={formData.ich_location_others || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                ICH의 추정 발생 위치 (ich_location_main)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Lobar", value: "Lobar" },
                    { label: "Basal Ganglia", value: "Basal Ganglia" },
                    { label: "Thalamus", value: "Thalamus" },
                    { label: "Brainstem", value: "Brainstem" },
                    { label: "Cerebellum", value: "Cerebellum" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_location_main"
                        value={option.value}
                        checked={formData.ich_location_main === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Rt. Temporal tip (ivh_mgraeb_rt_temp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=50%", value: "1 : <=50%" },
                    { label: "50 - 100%", value: "2 : 50 - 100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_rt_temp"
                        value={option.value}
                        checked={formData.ivh_mgraeb_rt_temp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Rt. Temporal tip expansion
                (ivh_mgraeb_rt_temp_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_rt_temp_exp"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_rt_temp_exp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Rt. Lateral ventricle (ivh_mgraeb_rt_lateral)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=25%", value: "1 : <=25%" },
                    { label: "25 - 50%", value: "2 : 25 - 50%" },
                    { label: "50 - 75%", value: "3 : 50 - 75%" },
                    { label: "75-100%", value: "4 : 75-100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_rt_lateral"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_rt_lateral === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Rt. Lateral ventricle expansion
                (ivh_mgraeb_rt_lateral_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_rt_lateral_exp"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_rt_lateral_exp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Rt. Occipital tip (ivh_mgraeb_rt_occip)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=50%", value: "1 : <=50%" },
                    { label: "50 - 100%", value: "2 : 50 - 100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_rt_occip"
                        value={option.value}
                        checked={formData.ivh_mgraeb_rt_occip === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Rt. Occipital tip expansion
                (ivh_mgraeb_rt_occip_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_rt_occip_exp"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_rt_occip_exp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Lt. Temporal tip (ivh_mgraeb_lt_temp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=50%", value: "1 : <=50%" },
                    { label: "50 - 100%", value: "2 : 50 - 100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_lt_temp"
                        value={option.value}
                        checked={formData.ivh_mgraeb_lt_temp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Lt. Temporal tip expansion
                (ivh_mgraeb_lt_temp_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_lt_temp_exp"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_lt_temp_exp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Lt. Lateral ventricle (ivh_mgraeb_lt_lateral)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=25%", value: "1 : <=25%" },
                    { label: "25 - 50%", value: "2 : 25 - 50%" },
                    { label: "50 - 75%", value: "3 : 50 - 75%" },
                    { label: "75-100%", value: "4 : 75-100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_lt_lateral"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_lt_lateral === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Lt. Lateral ventricle expansion
                (ivh_mgraeb_lt_lateral_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_lt_lateral_exp"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_lt_lateral_exp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Lt. Occipital tip (ivh_mgraeb_lt_occip)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=50%", value: "1 : <=50%" },
                    { label: "50 - 100%", value: "2 : 50 - 100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_lt_occip"
                        value={option.value}
                        checked={formData.ivh_mgraeb_lt_occip === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - Lt. Occipital tip expansion
                (ivh_mgraeb_lt_occip_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_lt_occip_exp"
                        value={option.value}
                        checked={
                          formData.ivh_mgraeb_lt_occip_exp === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - 3rd ventricle (ivh_mgraeb_3rd)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=50%", value: "1 : <=50%" },
                    { label: "50 - 100%", value: "2 : 50 - 100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_3rd"
                        value={option.value}
                        checked={formData.ivh_mgraeb_3rd === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - 3rd ventricle expansion (ivh_mgraeb_3rd_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_3rd_exp"
                        value={option.value}
                        checked={formData.ivh_mgraeb_3rd_exp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - 4th ventricle (ivh_mgraeb_4th)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "None", value: "0 : None" },
                    { label: "<=50%", value: "1 : <=50%" },
                    { label: "50 - 100%", value: "2 : 50 - 100%" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_4th"
                        value={option.value}
                        checked={formData.ivh_mgraeb_4th === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Modified Graeb - 4th ventricle expansion (ivh_mgraeb_4th_exp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Expanded", value: "1 : Expanded" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ivh_mgraeb_4th_exp"
                        value={option.value}
                        checked={formData.ivh_mgraeb_4th_exp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                Modifed Graeb scale (ivh_mgraeb_score)
                <span className="tooltip-container">
                  <span className="tooltip-icon">?</span>
                  <span className="tooltip-text">
                    【Modified Graeb Scale 자동계산 공식】
                    <br />
                    <br />
                    ★ 필수 입력 필드 (16개):
                    <br />
                    • 우측: ivh_mgraeb_rt_temp, ivh_mgraeb_rt_temp_exp,
                    <br />
                    &nbsp;&nbsp;ivh_mgraeb_rt_lateral,
                    ivh_mgraeb_rt_lateral_exp,
                    <br />
                    &nbsp;&nbsp;ivh_mgraeb_rt_occip, ivh_mgraeb_rt_occip_exp
                    <br />
                    <br />
                    • 좌측: ivh_mgraeb_lt_temp, ivh_mgraeb_lt_temp_exp,
                    <br />
                    &nbsp;&nbsp;ivh_mgraeb_lt_lateral,
                    ivh_mgraeb_lt_lateral_exp,
                    <br />
                    &nbsp;&nbsp;ivh_mgraeb_lt_occip, ivh_mgraeb_lt_occip_exp
                    <br />
                    <br />
                    • 중앙: ivh_mgraeb_3rd, ivh_mgraeb_3rd_exp,
                    <br />
                    &nbsp;&nbsp;ivh_mgraeb_4th, ivh_mgraeb_4th_exp
                    <br />
                    <br />
                    ★ 점수 체계:
                    <br />
                    • basic (temporal/occipital tip, 3rd/4th): 0-2점
                    <br />
                    • lateral (좌우 lateral ventricle): 0-4점
                    <br />
                    • expansion (모든 *_exp 필드): 0-1점
                    <br />
                    <br />
                    ★ 특별 계산 규칙:
                    <br />
                    • ivh_mgraeb_3rd: 점수 × 2
                    <br />
                    • ivh_mgraeb_4th: 점수 × 2
                    <br />
                    • 나머지 모든 필드: 점수 × 1
                    <br />
                    <br />★ 점수 범위: 0~30점
                  </span>
                </span>
              </label>
              <div className="input_1col">
                <input
                  type="text"
                  name="ivh_mgraeb_score"
                  value={formData.ivh_mgraeb_score || ""}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Acute hydrocephalus 여부 (ich_ivh_hydro)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh_hydro"
                        value={option.value}
                        checked={formData.ich_ivh_hydro === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                ICH volume - ABC/2 (ich_volume_abc)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_volume_abc"
                  value={formData.ich_volume_abc || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH 및 IVH의 원인 (ich_ivh_cause)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Spontaneous", value: "Spontaneous" },
                    {
                      label: "Arteriovenous malformation",
                      value: "Arteriovenous malformation",
                    },
                    { label: "Tumor", value: "Tumor" },
                    { label: "Moyamoya disease", value: "Moyamoya disease" },
                    { label: "Trauma", value: "Trauma" },
                    { label: "Ruptured aneurysm", value: "Ruptured aneurysm" },
                    {
                      label: "Thrombolytic agent (rt-PA)",
                      value: "Thrombolytic agent (rt-PA)",
                    },
                    { label: "Others, specify", value: "Others, specify" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh_cause"
                        value={option.value}
                        checked={formData.ich_ivh_cause === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text" style={{ fontSize: "13px" }}>
                        {option.label}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                ICH 및 IVH의 원인_others (ich_ivh_cause_others)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_ivh_cause_others"
                  value={formData.ich_ivh_cause_others || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                수술적 치료 여부 (ich_ivh_surgery)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh_surgery"
                        value={option.value}
                        checked={formData.ich_ivh_surgery === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column"></div>
          </div>
          {/* 수술적 치료 종류 */}
          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">
                수술적 치료 종류 (ich_ivh_surgery_name)
              </label>
              <div className="input_1col">
                <div className="rad-group vertical">
                  {[
                    {
                      label: "Decompressive craniectomy only",
                      value: "Decompressive craniectomy only",
                    },
                    {
                      label: "Decompressive craniectomy + hematoma evacuation",
                      value: "Decompressive craniectomy + hematoma evacuation",
                    },
                    {
                      label: "Craniotomy + hematoma evacuation",
                      value: "Craniotomy + hematoma evacuation",
                    },
                    {
                      label:
                        "Endoscopic or stereotactic hematoma evacuation (aspiration)",
                      value:
                        "Endoscopic or stereotactic hematoma evacuation (aspiration)",
                    },
                    {
                      label: "Intrahematoma catheter insertion",
                      value: "Intrahematoma catheter insertion",
                    },
                    {
                      label: "External ventricular drainage",
                      value: "External ventricular drainage",
                    },
                    {
                      label: "Intraventricular thrombolysis",
                      value: "Intraventricular thrombolysis",
                    },
                    {
                      label: "Intrahematoma thrombolysis",
                      value: "Intrahematoma thrombolysis",
                    },
                    { label: "Other, specify", value: "Other, specify" },
                  ].map((option) => (
                    <label key={option.value} className="checkbox-label">
                      <input
                        type="checkbox"
                        name="ich_ivh_surgery_name"
                        value={option.value}
                        checked={
                          Array.isArray(formData.ich_ivh_surgery_name) &&
                          formData.ich_ivh_surgery_name.includes(option.value)
                        }
                        onChange={handleCheckboxChange}
                      />
                      <span style={{ fontSize: "13px" }}>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                수술적 치료 종류_기타 (ich_ivh_surgery_others)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_ivh_surgery_others"
                  value={formData.ich_ivh_surgery_others || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                수술적 치료 시작 시각 (ich_ivh_surgery_dt)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_ivh_surgery_dt"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={dtDisplay(formData.ich_ivh_surgery_dt)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Midline shift supratentorial indicator (ich_ivh_midline_shift)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh_midline_shift"
                        value={option.value}
                        checked={
                          formData.ich_ivh_midline_shift === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                midline shift (ich_ivh_midline_shift_mm)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_ivh_midline_shift_mm"
                  value={formData.ich_ivh_midline_shift_mm || ""}
                  onChange={handleChange}
                />
                <span className="unit-text">mm</span>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                Cisternal compression status (ich_ivh_cistern_comp)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh_cistern_comp"
                        value={option.value}
                        checked={formData.ich_ivh_cistern_comp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                Ventricle - fourth shift effacement status
                (ich_ivh_fourth_vent_eff)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "No" },
                    { label: "Yes", value: "Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_ivh_fourth_vent_eff"
                        value={option.value}
                        checked={
                          formData.ich_ivh_fourth_vent_eff === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH score - GCS (ich_score_gcs)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "GCS 13-15", value: "0 : GCS 13-15" },
                    { label: "GCS 5-12", value: "1 : GCS 5-12" },
                    { label: "GCS 3-4", value: "2 : GCS 3-4" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_score_gcs"
                        value={option.value}
                        checked={formData.ich_score_gcs === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                ICH score - ICH volume (ich_score_ich)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    {
                      label: "ICH volume < 30㎤",
                      value: "0 : ICH volume < 30㎤",
                    },
                    {
                      label: "ICH volume ≥ 30㎤",
                      value: "1 : ICH volume ≥ 30㎤",
                    },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_score_ich"
                        value={option.value}
                        checked={formData.ich_score_ich === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH score - IVH 유무 (ich_score_ivh)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Yes", value: "1 : Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_score_ivh"
                        value={option.value}
                        checked={formData.ich_score_ivh === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                ICH score - Infratentorial origin of ICH
                (ich_score_infratentorial)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "No", value: "0 : No" },
                    { label: "Yes", value: "1 : Yes" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_score_infratentorial"
                        value={option.value}
                        checked={
                          formData.ich_score_infratentorial === option.value
                        }
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH score - Age (ich_score_age)
              </label>
              <div className="input_2col">
                <div className="rad-group vertical">
                  {[
                    { label: "Age < 80", value: "0 : Age < 80" },
                    { label: "Age ≥ 80", value: "1 : Age ≥ 80" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ich_score_age"
                        value={option.value}
                        checked={formData.ich_score_age === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="block-2column" />
          </div>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                ICH Score (ich_score)
                <span className="tooltip-container">
                  <span className="tooltip-icon">?</span>
                  <span className="tooltip-text">
                    【ICH Score 자동계산 공식】
                    <br />
                    <br />
                    ★ 필수 입력 필드 (5개):
                    <br />
                    • ich_score_gcs (GCS 점수, 0-2점)
                    <br />
                    • ich_score_ich (ICH 용적, 0-1점)
                    <br />
                    • ich_score_ivh (IVH 유무, 0-1점)
                    <br />
                    • ich_score_infratentorial (천막하 위치, 0-1점)
                    <br />
                    • ich_score_age (나이, 0-1점)
                    <br />
                    <br />
                    ★ 계산 공식:
                    <br />
                    ICH Score = GCS점수 + ICH용적점수 + IVH점수 + 천막하점수 +
                    나이점수
                    <br />
                    <br />
                    ★ 예시:
                    <br />
                    GCS=1점 + ICH용적=1점 + IVH=0점 + 천막하=0점 + 나이=1점
                    <br />
                    → 1 + 1 + 0 + 0 + 1 = 3점
                    <br />
                    <br />★ 점수 범위: 0~6점
                  </span>
                </span>
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  name="ich_score"
                  value={formData.ich_score || ""}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 미구현 조건부 필드들 - Ischemic stroke / Others */}
      {(formData.index_injury === "Ischemic stroke" ||
        formData.index_injury === "Others") && (
        <div className="basic-info-fieldset"></div>
      )}

      {/* 상태 체크 */}
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle" style={{ color: "#28a745" }}></h3>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Completion status_1 (initial_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Not started", value: "Not started" },
                  { label: "In process", value: "In process" },
                  { label: "Complete", value: "Complete" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="initial_status"
                      value={option.value}
                      checked={formData.initial_status === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>
      </div>
    </section>
  );
};

export default InitialPage;
